import { Action } from '@ngrx/store';
import { AlertPayload } from './model';

export enum AlertActionTypes {
  Add = '[HeaderAlert] Add message',
  Remove = '[HeaderAlert] Remove message',
  Clean = '[HeaderAlert] Clean messages',
}

export class Add implements Action {
  readonly type = AlertActionTypes.Add;
  constructor(public payload: { alert: AlertPayload }) {}
}

export class Remove implements Action {
  readonly type = AlertActionTypes.Remove;
  constructor(public payload: { ids: number[] }) {}
}

export class Clean implements Action {
  readonly type = AlertActionTypes.Clean;
}

export type AlertActions = Add | Remove | Clean;
